import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './SelectScope.css';
import RaisedButton from 'material-ui/RaisedButton';
import TopBar from '../../components/TopBar/TopBar';
import AyaSelector from '../../components/AyaSelector/AyaSelector'

class SelectScope extends Component {
  constructor() {
    super()

    this.scope = {
      start: 0,
      end: 0
    }
  }

  componentDidMount() {
    const inputs = ReactDOM.findDOMNode(this).getElementsByTagName('input')
    function select() { this.select() }
    for (let i=0; i < inputs.length; i++) {
      inputs[i].addEventListener('focus', select)
    }
  }

  saveScopeChanges = (scopeType, globalAya) => {
    this.scope[scopeType] = globalAya
  }

  handleSumit = () => {
    this.props.onSubmit(this.scope)
  }

  render() {
    return (
        <div className="page select-scope">
            <TopBar onBack={this.props.goToPage.bind(null, 'home')} title="بازگشت" />
            <main className="select-scope__main">
              <h3 className="select-scope__page-title">تعیین محدوده‌ی پرسش</h3>
              <AyaSelector
                title="از"
                generalAya={this.props.reviewRange.start}
                // range={this.props.reviewRange.start}
                onChanged={this.saveScopeChanges.bind(null, 'start')}
              />
              <AyaSelector
                title="تا"
                generalAya={this.props.reviewRange.end}
                // range={this.props.reviewRange.end}
                onChanged={this.saveScopeChanges.bind(null, 'end')}
              />
              <RaisedButton label="بپرس" secondary={true} style={{marginBottom: '1em'}} onClick={this.handleSumit} />
            </main>
        </div>
    );
  }
}

export default SelectScope;



// WEBPACK FOOTER //
// ./src/pages/SelectScope/SelectScope.jsx